
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"95","height":"109","viewBox":"0 0 95 109","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.662 29.554c-1.747-12.196 7.46-21.294 19.23-22.98m0 0l-8.011-3.52m8.011 3.52L20.1 15.038M88.62 79.02c1.945 12.167-7.113 21.413-18.855 23.291m0 0l8.068 3.389m-8.068-3.389l4.655-8.543","stroke":"#fff","stroke-width":"3.52","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"72.589","y":"80.884","width":"34.029","height":"64.537","rx":"5.28","transform":"rotate(165 72.59 80.884)","fill":"#fff","fill-opacity":".2","stroke":"#fff","stroke-width":"3.52"}})])
          )
        }
      }
    